export const TRADUCTOR_CONFIG = {
  MAX_WORDS: 2000,
  MAX_FILE_SIZE_MB: 5,
  ALLOWED_EXTENSIONS: ["pdf", "doc", "docx", "txt"],

  DEFAULT_PAIR: {
    es: "en",
    en: "es",
  },

  LANGUAGES: [
    { code: "es", label: "Español" },
    { code: "en", label: "Inglés" },
    { code: "fr", label: "Francés" },
    { code: "it", label: "Italiano" },
    { code: "qu", label: "Quechua" },
    { code: "ay", label: "Aymara" },
    { code: "cni", label: "Asháninka" },
  ],
};
